import React, { useCallback } from 'react'
import { FlatList, ListRenderItem } from 'react-native'

import styled from 'styled-components/native'

import { ProviderChatThread } from '../../molecules/providerChatThread/ProviderChatThread'
import { ProviderChatThreadModel } from '../../ui-models/messages/ProviderChatThreads'
import { tID } from '../../utils/utils'

const ItemSeparator = styled.View(({ theme }) => ({
  height: 1,
  backgroundColor: theme.colors.borderDefault,
}))

export type ProviderChatThreadListProps = {
  threads: ProviderChatThreadModel[]
  selectedId: string | null
  onThreadPress: (id: string) => void
}

export const ProviderChatThreadList: React.FC<ProviderChatThreadListProps> = ({
  threads,
  selectedId,
  onThreadPress,
}) => {
  const renderItem: ListRenderItem<ProviderChatThreadModel> = useCallback(
    ({ item }) => (
      <ProviderChatThread
        name={item.name}
        date={item.date}
        messagePreview={item.messagePreview}
        hasUnreadMessage={item.hasUnreadMessage}
        isSelected={item.id === selectedId}
        onPress={() => onThreadPress(item.id)}
      />
    ),
    [onThreadPress, selectedId],
  )

  return (
    <FlatList
      testID={tID('ProviderChatThreadList')}
      data={threads}
      renderItem={renderItem}
      keyExtractor={(item) => item.id}
      ItemSeparatorComponent={ItemSeparator}
      extraData={selectedId}
    />
  )
}
